<template>
  <div class="home">
    <div>
      <!-- <Header :path="{name: 'vivo.consulta.home'}" /> -->
      <Header />
    </div>

    <div class="main-holder">
      <busca />
      <!-- SLIDER -->
      <div v-if="!!sliders && sliders.sliderMelhorDesconto">
        <slider-desconto :data="sliders" :loading="sliderLoading" />
      </div>
      <div v-else>
        <slider :aparelhos="sliders" :loading="sliderLoading" />
      </div>

      <div v-if="showBannerParcelamento" class="bannerLojaPropria">
        <img
          src="./../../assets/imgs/banner_info_carrossel.jpg"
          @click="redirectToParcelamento"
          alt="Banner Parcelamento"
        />
      </div>

      <div class="bannerInfo" v-if="showBannerInfo">
        <img
          src="./../../assets/imgs/banner-parcelamento.png"
          alt="Banner Info"
          @click="redirectBanner"
        />
      </div>

      <div class="bannerBibliotech" v-else>
        <img
          src="./../../assets/imgs/banner-bibliotech-new.png"
          alt="Banner Bibliotech"
          @click="redirectToBibliotech"
        />
      </div>
    </div>

    <Listagem
      v-if="destaques && destaques.length > 0"
      icone="icone-titulo-smartphone.svg"
      titulo="Principais destaques Vivo"
      :lista="destaques"
      :loading="destaqueLoading"
      @orderBy="e => handleOrderBy(e)"
    />

    <div class="main-footer-holder">
      <div class="fale-conosco">
        <FaleConosco />
      </div>

      <MainFooter />
    </div>
    <botao-voltar-topo />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Header from '@/components/layout/header/Header.vue';
import MainFooter from '@/components/layout/footer/MainFooter.vue';
import Busca from '@/components/vivo-consulta/header/Busca.vue';
import Slider from '@/components/vivo-consulta/header/Slider.vue';
import SliderDesconto from '@/components/vivo-consulta/header/SliderMelhorDesconto.vue';
import Listagem from '@/components/vivo-consulta/conteudo/Listagem.vue';
import BotaoVoltarTopo from '@/components/BotaoVoltarTopo.vue';
import FaleConosco from '@/components/layout/conteudo/FaleConosco.vue';
import env from '../../config/env';
export default {
  name: 'VivoConsulta',
  components: {
    Header,
    MainFooter,
    Busca,
    SliderDesconto,
    Slider,
    Listagem,
    BotaoVoltarTopo,
    FaleConosco,
  },
  data() {
    return {
      filtros: [
        {
          titulo: 'Fabricante',
          tipo: 'opcao',
          nome: 'fabricante',
          escondido: true,
          parametros: ['Apple', 'Samsung', 'Asus', 'Motorola', 'Xiamoi'],
        },
        {
          titulo: 'Faixa de Valor',
          tipo: 'input-min-max',
          nome: 'faixadevalor',
          escondido: true,
          parametros: [],
        },
        {
          titulo: 'Memória Interna',
          tipo: 'opcao',
          nome: 'memoriainterna',
          escondido: true,
          parametros: ['0-8GB', '8-16GB', '16-32GB', '32-64GB', '64-128GB', '128-256GB', '256GB +'],
        },
        {
          titulo: 'Câmera Traseira',
          tipo: 'opcao',
          nome: 'cameratraseira',
          escondido: true,
          parametros: ['0-3MP', '3-6MP', '6-10MP', '10-15MP', '15-20MP', '20-25MP', '25MP +'],
        },
        {
          titulo: 'Câmera Frontal',
          tipo: 'opcao',
          nome: 'camerafrontal',
          escondido: true,
          parametros: ['0-3MP', '3-6MP', '6-10MP', '10-15MP', '15-20MP', '20-25MP', '25MP +'],
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      sliders: 'vcSlider/data',
      sliderLoading: 'vcSlider/loading',
      destaques: 'vcDestaque/data',
      destaqueLoading: 'vcDestaque/loading',
      tabela: 'vcTabela/tabela',
      ufId: 'vcUser/ufId',
    }),
    showBannerParcelamento() {
      return env.revista.canal === env.canal.loja_propria;
    },
    showBannerInfo() {
      return (
        env.revista.canal === env.canal.loja_propria ||
        env.revista.canal === env.canal.administrativo ||
        env.revista.canal === env.canal.parceiro
      );
    },
  },
  methods: {
    ...mapActions({
      getDestaques: 'vcDestaque/getDestaques',
      getSlider: 'vcSlider/getSliderPrincipal',
      handleOrderBy: 'vcDestaque/handleOrderBy',
      setTitle: 'apiRoute/setTitle',
    }),
    redirectToParcelamento() {
      window.location.href =
        'https://www.conteudosvivo.com.br/_sys/portal/#/categoria/gatilhos/post/nova-regra-de-parcelamento-de-smartphones-e-eletronicos';
    },
    redirectToBibliotech() {
      window.location.href =
        'https://www.conteudosvivo.com.br/_sys/portal/#/categoria/saiba/post/torne-se-um-especialista-em-smartphones-e-eletronicos-com-a-bibliotech';
    },
    redirectBanner() {
      if (env.revista.canal === env.canal.parceiro) {
        window.location.href =
          'https://www.conteudosvivo.com.br/_sys/portal/#/categoria/alavancas-comerciais/post/atualizacao-da-regra-de-parcelamento-de-smartphones-e-eletronicos-estoque-avancado';
        return;
      }

      window.location.href =
        'https://www.conteudosvivo.com.br/_sys/portal/#/categoria/alavancas-comerciais/post/atualizacao-da-regra-de-parcelamento-de-smartphones-e-eletronicos';
    },
  },
  mounted() {
    this.$nextTick(async () => {
      this.setTitle({ title: 'Vivo Consulta', system: 2 });
      if (this.tabela) {
        this.getSlider({
          tabela: this.tabela,
          ufId: this.ufId,
        });
        this.getDestaques({
          tabela: this.tabela,
          ufId: this.ufId,
        });
      } else {
        this.$store.subscribe(mutation => {
          const { type, payload } = mutation;
          switch (type) {
            case 'vcTabela/TABELA_ADD':
              this.getSlider({
                tabela: payload.tabela,
                ufId: this.ufId,
              });
              this.getDestaques({
                tabela: payload.tabela,
                ufId: this.ufId,
              });
          }
        });
      }
    });
  },
};
</script>

<style scoped lang="scss">
.home {
  width: 100%;
}
.main-holder {
  padding-top: 110px;
  background: url('./../../assets/imgs/pattern_header.png');
  width: 100%;
  background-repeat: no-repeat;
}

.main-footer-holder {
  padding: 40px 0px 0px;
  margin-top: 30px;
}

.bannerLojaPropria,
.bannerBibliotech,
.bannerInfo {
  width: 100%;
  text-align: center;
}

.bannerLojaPropria img,
.bannerBibliotech img,
.bannerInfo img {
  height: auto;
  max-width: 100%;
  max-height: 325px;
  cursor: pointer;
}
</style>
